import { useState, useEffect } from 'react'
import { Container } from 'reactstrap'
import { CONTACT_PROPOSAL_STATUS } from 'components/Contact/constants'
import s from './Proposals.scss'
import { Tabs } from 'components/ideal-core-ui'
import { ProposalsTable } from 'components/common/ProposalsTable'

const Proposals = ({ proposals, wonProposals, lostProposals, contact }) => {
  const [contactProposals, setContactProposals] = useState(proposals)

  useEffect(() => {
    setContactProposals(proposals)
  }, [proposals])

  const filterProposals = status => {
    switch (status) {
      case CONTACT_PROPOSAL_STATUS.WON:
        setContactProposals(wonProposals)
        break
      case CONTACT_PROPOSAL_STATUS.LOST:
        setContactProposals(lostProposals)
        break
      default:
        setContactProposals(proposals)
    }
  }

  return (
    <Container>
      <section className={s.proposalsContainer}>
        <Tabs
          activeTabKey="active"
          className={s.main}
          tabs={[
            {
              key: 'active',
              label: 'Active',
              cb: () => filterProposals(CONTACT_PROPOSAL_STATUS.ACTIVE),
              value: (
                <ProposalsTable
                  companyProposals={contactProposals}
                  contact={contact}
                  label="Active Proposals"
                />
              )
            },
            {
              key: 'won',
              label: 'Won',
              cb: () => filterProposals(CONTACT_PROPOSAL_STATUS.WON),
              value: (
                <ProposalsTable
                  companyProposals={contactProposals}
                  contact={contact}
                  label="Won Proposals"
                />
              )
            },
            {
              key: 'lost',
              label: 'Lost',
              cb: () => filterProposals(CONTACT_PROPOSAL_STATUS.LOST),
              value: (
                <ProposalsTable
                  companyProposals={contactProposals}
                  contact={contact}
                  label="Lost Proposals"
                />
              )
            }
          ]}
        />
      </section>
    </Container>
  )
}

export default Proposals
